module.exports = __webpack_public_path__ + "img/img-3.fd46a619.png";